module.exports = __webpack_public_path__ + "img/adult-moc3-runamoc-turquoise_1.ca1af7f3.jpg";